<template>
  <div class="primary-box">
    <h2 class="box-title" v-html="title" />
    <p v-html="description" />
    <slot/>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: String,
    description: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
